.imageBackdrop {
  background-size: cover;
  height: 100%;
  width: 100%;
}
.imageBackdrop.welcome {
  background-image: url("./images/backgrounds/petito-moreno.webp");
}
.imageBackdrop.deletion {
  background-image: url("./images/account_deletion_background.jpg");
}